import {useMemo} from 'react';
import {useNavigate,useSearchParams} from 'react-router-dom';
import {useAuth} from '../App';
import {SupplierBaselineScreen} from '../../../packages/shared/supplier-baseline/ui/Screen';
import {baselineAccountKey} from '../../../packages/shared/supplier-baseline/client';
import {baselineHref} from '../../../packages/shared/supplier-baseline/draft';
import './supplier-return-setup.css';
const base=import.meta.env.VITE_API_URL||'https://api.whenlyapp.com';
export default function SupplierReturnSetup(){
 const {user,currentShop,currentOrganization,hasPermission}=useAuth(),navigate=useNavigate(),[search]=useSearchParams();
 const account=useMemo(()=>({userId:String(user?.id||''),domain:currentShop?.domain||'',organizationId:currentOrganization?.id||currentShop?.organizationId||''}),[user?.id,currentShop?.domain,currentOrganization?.id,currentShop?.organizationId]);
 if(!account.userId||!account.domain||!hasPermission('supplier_returns.view'))return <p role="alert">Select a company with supplier-return access.</p>;
 return <div className="supplier-return-office">
   <SupplierBaselineScreen key={baselineAccountKey(base,account)} base={base} account={account}
     returnId={search.get('return')||''} itemId={search.get('line')||''}
     canEdit={hasPermission('inventory.manage')&&hasPermission('supplier_returns.manage')}
     onSelect={s=>navigate(s?baselineHref(s):'/supplier-return-setup')} onBack={()=>navigate('/supplier-returns')}
     onReturn={id=>navigate('/supplier-returns/'+id)} onEnrollment={()=>navigate('/stock-enrollment')}/>
 </div>;
}
